export default (url) => ({
    available: true,
    internalButtonContext: 'btn-blue',
    url: url,

    get availableClass() {
        return !this.available ? 'disabled' : '';
    },

    click() {
        if (!this.available) {
            return;
        }

        this.available = false;

        axios.get(this.url)
            .then(response => this.internalButtonContext = 'btn-green')
            .catch(error => this.internalButtonContext = 'btn-red')
            .finally(() => this.available = true);
    },

    reset() {
        this.internalButtonContext = 'btn-blue';
    },
});
